import React, { useState, useEffect, useRef } from 'react';
import usePortalAuth from '../../../../auth/usePortalAuth';
import ReactPlayer from 'react-player';
import basePCUrl from '../../../../Globals';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: 12,
    padding: theme.spacing(3),
    maxWidth: 640,
  },
  header: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
  icon: {
    fontSize: 48,
    color: theme.palette.error.main,
    marginBottom: theme.spacing(1),
  },
  score: {
    fontWeight: 700,
  },
  message: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(0.5),
  },
  playerWrapper: {
    marginTop: theme.spacing(2),
    borderRadius: 8,
    overflow: 'hidden',
  },
  button: {
    marginTop: theme.spacing(3),
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    padding: theme.spacing(1, 4),
  },
}));

const TrainingFailModal = (props) => {
  const classes = useStyles();
  const [videoType, setVideoType] = useState();
  const [videoProgress, setVideoProgress] = useState();
  const reactPlayerRef = useRef();
  const { getAccessTokenSilently } = usePortalAuth();

  const pushToDashboard = () => {
    props.history.push({
      pathname: '/Dashboard/History',
    });
    window.scrollTo({ top: 110, left: 100, behavior: 'smooth' });
  };

  const resetQuiz =()=> {
  props.setCurrentQuestion(1); // Reset to the first question
  props.setSelectedAnswer(null); // Clear the selected answer
  props.setUserAnswers([]); // Clear the user's previous answers
  props.setScore(0); // Reset the score to 0
  props.setIsNextDisabled(true);
  props.toggle()
  saveTrainingProgress()
  }


  const saveTrainingProgress = async (event) => {
    //event.preventDefault();
    const token = await getAccessTokenSilently();
    var api = 'https://zsvz1vz9rg.execute-api.us-west-2.amazonaws.com/prod';
    
    const date = new Date();
    var data = {
      trainingModule: props.trainingId,
      status: 'required',
      startDate: date,
      videoProgress: videoProgress
    };

    fetch(basePCUrl, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${token}`,
        Action: 'updateUserTraining',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          //setError(true);
          // console.log(error);
          return;
        }

        response.json().then((data) => {
          return;
        });
      })
      .catch(function (err) {
        console.log('Fetch Error :-S', err);
      });
  };

  const getAdminConfigSettings = async () => {
    const token = await getAccessTokenSilently();

    return new Promise(async (resolve, reject) => {

      fetch(basePCUrl, {
        method: 'get',
        headers: {
          Action: 'adminConfigs',
          //testacct: uid,
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          if (response.status !== 200) {
            console.log('Looks like there was a problem. Status Code: ' + response.status);
            return;
          }

          response.json().then((data) => {
            if (data !== 'access token check failed') {
              setVideoType(data.settings.trainingSettings.videoType)
              resolve(data);
            } else {
              resolve(data);
              return;
            }
          });
        })
        .catch(function (err) {
          console.log('Fetch Error :-S', err);
        });
    });
  };

  useEffect(() => {
    getAdminConfigSettings();
  }, []);

  return (
    <Dialog
      onClose={props.toggle}
      disableBackdropClick={true}
      aria-labelledby="Quiz Results"
      open={props.modal}
      PaperProps={{ className: classes.dialogPaper }}
    >
      <Box className={classes.header}>
        <ErrorOutlineIcon className={classes.icon} />
        <Typography variant="h5" className={classes.score}>
          {props.scorePercentage}%
        </Typography>
        <Typography variant="body1" className={classes.message}>
          You got {props.correctAnswersCount} out of {props.quizLength} correct.
        </Typography>
        <Typography variant="body2" color="textSecondary" style={{ marginTop: 4 }}>
          Please watch the training video below and try again.
        </Typography>
      </Box>

      <Box className={classes.playerWrapper}>
        <ReactPlayer
          url={props.trainingVideo}
          ref={reactPlayerRef}
          width="100%"
          controls={true}
          onPause={() => {
            console.log(
              'Percentage: ' +
                Math.floor(
                  (reactPlayerRef.current.getCurrentTime() /
                    reactPlayerRef.current.getDuration()) *
                    100
                )
            );
          }}
          onEnded={() => {
            setVideoProgress(
              Math.floor(
                (reactPlayerRef.current.getCurrentTime() /
                  reactPlayerRef.current.getDuration()) *
                  100
              )
            );
          }}
        />
      </Box>

      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        disabled={videoProgress !== 100}
        onClick={resetQuiz}
        fullWidth
      >
        Return to Quiz
      </Button>
    </Dialog>
  );
};
export default TrainingFailModal;
